<template>
  <div class="jtk-demo-canvas canvas-wide flowchart-demo jtk-surface jtk-surface-nopan" id="canvas" :style="{position: 'relative', height: heightValue}">
    <div class="window jtk-node" v-for="(eachStage, key, index) in stages" :key="key" :style="positionStage(eachStage, key, index)" :id="key">{{key}} <br/> {{truncateText(eachStage.text[0].eng)}} </div>
  </div>
</template>

<script>
import jsplumb from 'jsplumb'
export default {
  name: 'app-create-sms-app',
  methods: {
    positionStage (eachStage, stage, parentIndex) {
      const ensureArray = item => Array.isArray(item) ? item : Array.of(item)

      let position = { top: `${parentIndex * 10}em`, left: 'calc((100% - 300px) / 2)' }
      if (eachStage.next && ensureArray(eachStage.next)) {
        ensureArray(eachStage.next).forEach((nextStage, index) => {
          if (index === 0) {
            position.left = `20em`
          } else {
            position.left = `${index * 3}em`
            position.top = `${parentIndex * 10}em`
          }
        })
      } else {
        position.left = 'calc((100% - 300px))'
      }
      return position
    },

    truncateText (text) {
      return text.length > 50 ? `${text.slice(0, 48)} ...` : text
    }
  },
  props: ['config'],
  data () {
    const ensureArray = item => Array.isArray(item) ? item : Array.of(item)

    const reorder = (input) => {
      const perform = (stageKey, parent, results) => {
        const stage = parent[stageKey]

        if (!stage.next) {
          results[stageKey] = stage
          return
        }

        const next = ensureArray(stage.next)

        next.forEach(key => {
          results[key] = parent[key]
        })
      }

      const { uninitialized, ...rest } = input
      const results = { uninitialized }
      const uninitializedNext = ensureArray(uninitialized.next)

      uninitializedNext.forEach(key => {
        results[key] = rest[key]
      })

      const visited = new Set(['uninitialized'])

      while (Object.keys(input).length !== Object.keys(results).length) {
        const unvisited = Object.keys(results)

        unvisited.forEach(key => {
          if (!visited.has(key)) {
            perform(key, input, results)
            visited.add(key)
          }
        })
      }

      return results
    }
    const stages = reorder(this.config.stages)
    return {
      stages
    }
  },
  computed: {
    heightValue: function () {
      return `${(Object.keys(this.stages).length * 130)}px`
    }
  },
  mounted () {
    Object.keys(this.stages).forEach((eachStage, index) => {
      if (this.stages[eachStage].next) {
        if (Array.isArray(this.stages[eachStage].next)) {
          this.stages[eachStage].outgoing = this.stages[eachStage].next.length
          this.stages[eachStage].next.forEach(eachNext => {
            this.stages[eachNext].incoming = this.stages[eachNext].incoming ? this.stages[eachNext].incoming + 1 : 1
          })
        } else {
          this.stages[eachStage].outgoing = 1
          this.stages[this.stages[eachStage].next].incoming = this.stages[this.stages[eachStage].next].incoming ? this.stages[this.stages[eachStage].next].incoming + 1 : 1
        }
      }
    })
    const jsPlumb = jsplumb.jsPlumb
    jsPlumb.ready(() => {
      var instance = (window.jsp = jsPlumb.getInstance({
        // default drag options
        DragOptions: { cursor: 'pointer', zIndex: 2000 },
        // the overlays to decorate each connection with.  note that the label overlay uses a function to generate the label text; in this
        // case it returns the 'labelText' member that we set on each connection in the 'init' method below.
        ConnectionOverlays: [
          [
            'Arrow',
            {
              location: 1,
              visible: true,
              width: 11,
              length: 11,
              id: 'ARROW',
              events: {
                click: function () {
                  alert('you clicked on the arrow overlay')
                }
              }
            }
          ],
          [
            'Label',
            {
              location: 0.1,
              id: 'label',
              cssClass: 'aLabel',
              events: {
                tap: function () {
                  alert('hey')
                }
              }
            }
          ]
        ],
        Container: 'canvas'
      }))

      var basicType = {
        connector: 'StateMachine',
        paintStyle: { stroke: 'red', strokeWidth: 4 },
        hoverPaintStyle: { stroke: 'blue' },
        overlays: ['Arrow']
      }
      instance.registerConnectionType('basic', basicType)

      // this is the paint style for the connecting lines..
      var connectorPaintStyle = {
        strokeWidth: 2,
        stroke: '#61B7CF',
        joinstyle: 'round',
        outlineStroke: 'white',
        outlineWidth: 2
      }
        // .. and this is the hover style.
      var connectorHoverStyle = {
        strokeWidth: 3,
        stroke: '#216477',
        outlineWidth: 5,
        outlineStroke: 'white'
      }
      var endpointHoverStyle = {
        fill: '#216477',
        stroke: '#216477'
      }
        // the definition of source endpoints (the small blue ones)
      var sourceEndpoint = {
        endpoint: 'Dot',
        paintStyle: {
          stroke: '#7AB02C',
          fill: 'transparent',
          radius: 7,
          strokeWidth: 1
        },
        isSource: true,
        connector: [
          'Flowchart',
          {
            stub: [10, 10],
            gap: 5,
            cornerRadius: 5,
            alwaysRespectStubs: true,
            midpoint: 0.0000001
          }
        ],
        connectorStyle: connectorPaintStyle,
        hoverPaintStyle: endpointHoverStyle,
        connectorHoverStyle: connectorHoverStyle,
        dragOptions: {},
        overlays: [
          [
            'Label',
            {
              location: [0.5, 1.5],
              label: 'Drag',
              cssClass: 'endpointSourceLabel',
              visible: false
            }
          ]
        ]
      }
        // the definition of target endpoints (will appear when the user drags a connection)
      var targetEndpoint = {
        endpoint: 'Dot',
        paintStyle: { fill: '#7AB02C', radius: 7 },
        hoverPaintStyle: endpointHoverStyle,
        maxConnections: -1,
        dropOptions: { hoverClass: 'hover', activeClass: 'active' },
        isTarget: true,
        overlays: [
          [
            'Label',
            {
              location: [0.5, -0.5],
              label: 'Drop',
              cssClass: 'endpointTargetLabel',
              visible: false
            }
          ]
        ]
      }
      var init = function (connection) {
        connection
          .getOverlay('label')
          .setLabel(getLabel(connection.sourceId, connection.targetId))
      }

      const getLabel = (sourceId, targetId) => {
        if (Array.isArray(this.stages[sourceId].next)) {
          const index = this.stages[sourceId].next.indexOf(targetId)
          return this.stages[sourceId].options[index].toString()
        }
        return ''
      }

      var _addEndpoints = function (toId, sourceAnchors, targetAnchors) {
        for (var i = 0; i < sourceAnchors.length; i++) {
          var sourceUUID = toId + sourceAnchors[i]
          instance.addEndpoint(toId, sourceEndpoint, {
            anchor: ['Perimeter', { shape: 'Rectangle', anchorCount: 50 }],
            uuid: sourceUUID
          })
        }
        for (var j = 0; j < targetAnchors.length; j++) {
          var targetUUID = toId + targetAnchors[j]
          instance.addEndpoint(toId, targetEndpoint, {
            anchor: ['Perimeter', { shape: 'Rectangle', anchorCount: 150 }],
            uuid: targetUUID
          })
        }
      }

      // suspend drawing and initialise.
      instance.batch(() => {
        const endpointNodes = ['TopCenter', 'LeftMiddle', 'RightMiddle', 'BottomCenter']
        const endpointNodesReversed = Array.from(endpointNodes).reverse()
        Object.keys(this.stages).forEach((eachStage, index) => {
          let inPoints = []
          let outPoints = []
          inPoints = endpointNodes.slice(0, this.stages[eachStage].incoming || 0)
          outPoints = endpointNodesReversed.slice(0, this.stages[eachStage].outgoing)
          _addEndpoints(eachStage, outPoints, inPoints)
        })

        // listen for new connections; initialise them the same way we initialise the connections at startup.
        instance.bind('connection', function (connInfo, originalEvent) {
          init(connInfo.connection)
        })

        // make all the window divs draggable
        instance.draggable(jsPlumb.getSelector('.flowchart-demo .window'), {
          grid: [20, 20]
        })
        // THIS DEMO ONLY USES getSelector FOR CONVENIENCE. Use your library's appropriate selector
        // method, or document.querySelectorAll:
        // jsPlumb.draggable(document.querySelectorAll('.window'), { grid: [20, 20] })

        Object.keys(this.stages).forEach((eachStage, index) => {
          // check if next stages is not an array
          if (this.stages[eachStage].next) {
            let nextStage = this.stages[eachStage].next
            const endpointNodes = ['TopCenter', 'LeftMiddle', 'RightMiddle', 'BottomCenter']
            const endpointNodesReversed = Array.from(endpointNodes).reverse()
            // let connector = ['RightMiddle', 'LeftMiddle', 'BottomCenter']
            if (!Array.isArray(nextStage)) {
              nextStage = [nextStage]
              // connector = endpointNodesReversed[0]
            }
            // there's a need to track the number of incoming connections for each stage
            // this will prevent attempting to link two connections to the same endpoint
            nextStage.forEach((everyNextStage, index) => {
              if (!this.stages[everyNextStage].plottedIncoming) {
                this.stages[everyNextStage].plottedIncoming = 0
              }
              instance.connect({
                uuids: [`${eachStage}${endpointNodesReversed[index]}`, `${everyNextStage}${endpointNodes[this.stages[everyNextStage].plottedIncoming]}`]
              })
              ++this.stages[everyNextStage].plottedIncoming
            })
          }
        })

        //
        // listen for clicks on connections, and offer to delete connections on click.
        //
        instance.bind('click', function (conn, originalEvent) {
          // if (confirm('Delete connection from ' + conn.sourceId + ' to ' + conn.targetId + '?'))
          //   instance.detach(conn);
          conn.toggleType('basic')
        })

        instance.bind('connectionDrag', function (connection) {
          console.log(
            'connection ' +
              connection.id +
              ' is being dragged. suspendedElement is ',
            connection.suspendedElement,
            ' of type ',
            connection.suspendedElementType
          )
        })

        instance.bind('connectionDragStop', function (connection) {
          console.log('connection ' + connection.id + ' was dragged')
        })

        instance.bind('connectionMoved', function (params) {
          console.log('connection ' + params.connection.id + ' was moved')
        })
      })

      jsPlumb.fire('jsPlumbDemoLoaded', instance)
    })
  }
}
</script>

<style>
.demo {
  /* for IE10+ touch devices */
  touch-action: none;
}

.flowchart-demo .window {
  border: 1px solid #346789;
  box-shadow: 2px 2px 19px #aaa;
  -o-box-shadow: 2px 2px 19px #aaa;
  -webkit-box-shadow: 2px 2px 19px #aaa;
  -moz-box-shadow: 2px 2px 19px #aaa;
  -moz-border-radius: 0.5em;
  border-radius: 0.5em;
  opacity: 0.8;
  width: 300px;
  height: 100px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;
  z-index: 20;
  position: absolute;
  background-color: #eeeeef;
  color: black;
  font-family: helvetica, sans-serif;
  padding: 0.5em;
  font-size: 0.9em;
  -webkit-transition: -webkit-box-shadow 0.15s ease-in;
  -moz-transition: -moz-box-shadow 0.15s ease-in;
  -o-transition: -o-box-shadow 0.15s ease-in;
  transition: box-shadow 0.15s ease-in;
}

.flowchart-demo .window:hover {
  box-shadow: 2px 2px 19px #444;
  -o-box-shadow: 2px 2px 19px #444;
  -webkit-box-shadow: 2px 2px 19px #444;
  -moz-box-shadow: 2px 2px 19px #444;
  opacity: 0.6;
}

.flowchart-demo .active {
  border: 1px dotted green;
}

.flowchart-demo .hover {
  border: 1px dotted red;
}

.flowchart-demo .jtk-connector {
  z-index: 4;
}

.flowchart-demo .jtk-endpoint,
.endpointTargetLabel,
.endpointSourceLabel {
  z-index: 21;
  cursor: pointer;
}

.flowchart-demo .aLabel {
  background-color: white;
  padding: 0.4em;
  font: 12px sans-serif;
  color: #444;
  z-index: 21;
  border: 1px dotted gray;
  opacity: 0.8;
  cursor: pointer;
}

.flowchart-demo .aLabel.jtk-hover {
  background-color: #5c96bc;
  color: white;
  border: 1px solid white;
}

.window.jtk-connected {
  border: 1px solid green;
}

.jtk-drag {
  outline: 4px solid pink !important;
}

path,
.jtk-endpoint {
  cursor: pointer;
}

.jtk-overlay {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// preview.vue?f69d4818